jQuery(document).ready(function($) {

    const apiDomain = 'https://teamcoadmin.com/';
    const productid = $("#productid").val();

    $.ajax({
        url: apiDomain + "api/product/" + productid,
        type: 'GET',
        dataType: 'json',
        async: false
    }).done(function (result) {
        if (result.data != 'not found') {
            const svgData = result.data.svg_info;

            switch (result.data.builder_type) {
                case "dynamic":
                    renderDynamicForm(svgData);
                    loadGarmentsList();
                    renderColors();
                    renderDynamicColorsNote();
                    showDragSVG(result.data.url_svg);
                    renderButtonSave(productid);
                    setDataChange(result.data.dataExtra);
                    renderSaveLocal();
                    break;
                case "artisan":
                    renderArtisanForm();
                    loadGarmentsList();
                    break;
                case "classic":
                default:
                    showInfoSVG(svgData, productid);
                    renderColors();
                    showDragSVG(result.data.url_svg);
                    renderButtonSave(productid);
                    setDataChange(result.data.dataExtra);
                    renderSaveLocal();
                    break;
            }

            /*if (result.data.url_svg != null) {
                const url = apiDomain + "jerseys/" + result.data.url_svg + ".svg";
                xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.overrideMimeType("image/svg+xml");
                xhr.send("");
                document.getElementById("dragSVG").appendChild(xhr.responseXML.documentElement);
            }*/

            /*if (result.data.builder_type !== 'artisan') {
                renderButtonSave(productid);
                setDataChange(result.data.dataExtra);
                renderSaveLocal();
            }*/

            $('.product-single__form').hide();
        }
    }).fail(function (result) {
        console.log(result);
    });

    function showInfoSVG(svgData, productid) {
        var qty = 1;
        var html = '<h5 class="m-0">Preview Colors</h5>';
        html += '<div class="small-text mb-1">(Please note that colors are approximate)</div>';
        html += '<h6>Select color to change</h6>';
        html += '<div class="previewColors">';
        html += '<form class="formInfoColors">';
        html += '<input type="hidden" name="productId" value="' + productid + '">';
        $.each(svgData, function(i, val) {
            if (val.hide == null) {
                html += "<div class='list-colors custom-color-picker-block'>";
                html += "<span>Color " + (qty++) + "</span>";
                html += "<div class='custom-color-picker'>";
                html += "<div fortype='" + val.type + "' id='" + val.class + "' class='color colorChange' style='background-color:" + val.colorCode + "' forclass='" + val.class + "' onclick=''>";
                /* Updates ApoloMultimedia */
                html += "<input type='hidden' name='customColorName[" + val.class + "]' value='" + val.colorName + ":" + val.colorCode + "'>";
                /* End Updates ApoloMultimedia */
                html += "</div>";
                html += "</div>";
                html += "<label>" + val.colorName + "</label>";
                html += "<input type='hidden' name='customColor[" + val.class + "]' id='custom" + val.class + "' value='" + val.colorCode + "'>";
                html += "</div>";
            }
        });
        html += '</form>';
        html += "</div>";
        $('#colorSVG').append(html);
    }

    function showDragSVG(url_svg) {
        $.ajax({
            url: apiDomain + "jerseys/" + url_svg + ".svg",
            type: 'GET',
            dataType: 'xml', // Указываем, что ожидаем XML (SVG)
            success: function(response) {
                // Находим корневой SVG элемент и добавляем его в #dragSVG
                var svgElement = $(response).find('svg').first();
                if (svgElement.length) {
                    $('#dragSVG').html(svgElement);
                } else {
                    console.error('SVG element not found in response');
                }
            },
            error: function(xhr, status, error) {
                console.error('Error loading SVG:', status, error);
            }
        });
    }

    function renderColors() {
        console.log('renderColors');

        $.ajax({
            url: apiDomain + "api/colors",
            data: {'productid': productid},
            type: 'GET',
            success: function(result) {
                var html = '<div>';
                $.each(result.data, function(i, val) {
                    html += "<div class='list-colors'>";
                    html += "<div class='custom-true-color-picker'>";
                    html += "<div class='color' customcolorid='" + val.value_code + "' customcolortitle='" + val.name + "' style='background-color:" + val.value_code + "' data-color='" + val.value_code + "' onclick=''>";
                    html += "</div>";
                    html += "</div>";
                    html += "<label>" + val.name + "</label>";
                    html += "</div>";
                });
                html += "</div>";
                $('#colors').append(html);
            }
        });
    }

    function renderSaveLocal() {
        $('#saveLocal').append('<a id="butonSaveLocal" onclick="" class="btn btn--full add-to-cart">GET A QUOTE</a>');
    }

    function saveClassicData(){
        let newColors = $('.formInfoColors').serialize();
        let Url = newSVG(newColors, 'save');

        saveLocal(Url);

        $('#myModal').css({'display':'block'});
    }

    function saveLocal(Url) {
        let newColors = $('.formInfoColors').serializeArray();
        let titleProduct = $('.product-single__title').html();
        let idProduct = $('input[name="productId"]').val();
        var Product = {"garment_type": []};

        Product['title'] = titleProduct;
        Product['colors'] = [];
        newColors.map((item) => {
            if (item.name === 'garment_type[]') {
                Product['garment_type'].push(item.value);
            }

            if (item.name.includes('customColorName')) {
                let splitedColors = item.value.split(':');
                Product['colors'].push({
                    'name': splitedColors[0],
                    'code': splitedColors[1]
                });
            }
        });

        if (document.cookie.indexOf("requestProductToken=") >= 0) {
            storeRequestProduct(Product, idProduct, getCookie("requestProductToken"), Url);
        } else {
            expiry = new Date();
            expiry.setTime(expiry.getTime() + (100 * 60 * 1000)); // Ten minutes
            document.cookie = "requestProductToken=" + getToken() + "; expires=" + expiry.toGMTString() + ";path=/";
            storeRequestProduct(Product, idProduct, getCookie("requestProductToken"), Url);
        }

        $('#popup').fadeIn('slow');
        $('.popup-overlay').height($(window).height()).fadeIn('slow');
    }

    function renderButtonSave(id) {
        $('#link').append('<a id="saveSVG" onclick="">Save Image</a>');
    }

    function saveSVG() {
        let newColors = $('.formInfoColors').serialize();

        newSVG(newColors, 'download');
    }

    function storeRequestProduct(data, idProduct, token, url) {
        var dataRequest = {};
        dataRequest['token'] = token;
        dataRequest['product_id'] = idProduct;
        dataRequest['data'] = data;
        dataRequest['url_svg'] = url;
        console.log(dataRequest);
        $.ajax({
            url: apiDomain + "api/storeProduct",
            type: 'POST',
            data: dataRequest,
            dataType: 'json',
            async: false
        }).done(function(result) {
        }).fail(function(result) {});
        $('#my-quote-icon').removeClass('hide');
    }

    function getToken() {
        var token = '';
        $.ajax({
            url: apiDomain + "api/getToken",
            type: 'GET',
            dataType: 'json',
            async: false
        }).done(function(result) {
            token = result.data;
        }).fail(function() {});
        return token;
    }

    function getCookie(name) {
        var re = new RegExp(name + "=([^;]+)");
        var value = re.exec(document.cookie);
        return (value != null) ? unescape(value[1]) : null;
    }

    function newSVG(newColors, saveOrDownload) {
        var image = '';
        var name = '';
        $.ajax({
            url: apiDomain + "api/image",
            type: 'POST',
            data: newColors,
            dataType: 'json',
            async: false
        }).done(function(result) {
            image = apiDomain + 'jerseys/' + result.data + '.svg';
            name = result.data;
        }).fail(function() {});
        switch (saveOrDownload) {
            case 'save':
                return image;
                break;
            case 'download':
                forceDownload(image, name);
                break;
        }
    }

    function forceDownload(url, fileName) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = function() {
            var urlCreator = window.URL || window.webkitURL;
            var imageUrl = urlCreator.createObjectURL(this.response);
            var tag = document.createElement('a');
            tag.href = imageUrl;
            tag.download = fileName;
            document.body.appendChild(tag);
            tag.click();
            document.body.removeChild(tag);
        }
        xhr.send();
    }

    function setDataChange(jsonData) {
        var itemColor = {
            background: jsonData.background,
            colors: jsonData.colors,
            gradients: [],
            selected: '',
            type: '',
            lineargradients: jsonData.linearGradients,
            colorToGradient: jsonData.colorToGradient,
            calculateGradients: function(startColor, endColor) {
                this.gradients = [];
                for (var i = 0; i < 256; i++) {
                    this.gradients[i] = [];
                    this.gradients[i].push(Math.round(startColor.r + (endColor.r - startColor.r) * i / 255));
                    this.gradients[i].push(Math.round(startColor.g + (endColor.g - startColor.g) * i / 255));
                    this.gradients[i].push(Math.round(startColor.b + (endColor.b - startColor.b) * i / 255));
                }
            },
            setGradient: function(className, startColor, endColor) {
                this.calculateGradients(startColor, endColor);
                lengthOfGradient = this.lineargradients[className].length;
                for (var i = 0; i < lengthOfGradient; i++) {
                    var tmpColorArray = this.gradients[this.lineargradients[className][i]['idxRGB']];
                    var gradColor = itemColor.rgbToHex(tmpColorArray[0], tmpColorArray[1], tmpColorArray[2]);
                    this.lineargradients[className][i]['color'] = gradColor;
                    $('[forClass="' + className + '"][num="' + i + '"]')
                        .css('background-color', gradColor);
                }
                $('.' + className).each(function(i) {
                    $(this).children('stop').each(function(j) {
                        $(this).css('stop-color', itemColor.lineargradients[className][j]['color']);
                    });
                });
            },
            setTmpGradient: function(className, startColor, endColor) {
                this.calculateGradients(startColor, endColor);
                $('.' + className).each(function(i) {
                    $(this).children('stop').each(function(j) {
                        var tmpColorArray = itemColor.gradients[itemColor.lineargradients[className][j]['idxRGB']];
                        var gradColor = itemColor.rgbToHex(tmpColorArray[0], tmpColorArray[1], tmpColorArray[2]);
                        $(this).css('stop-color', gradColor);
                        $('[forClass="' + className + '"][num="' + j + '"]')
                            .css('background-color', gradColor);
                    });
                });
            },
            componentToHex: function(c) {
                var hex = c.toString(16);
                return hex.length == 1 ? "0" + hex : hex;
            },
            rgbToHex: function(r, g, b) {
                return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
            },
            hexToRgb: function(hex) {
                var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                return result ? {
                    r: parseInt(result[1], 16),
                    g: parseInt(result[2], 16),
                    b: parseInt(result[3], 16)
                } : null;
            },
            convertRGB: function(color) {
                var digits = /(.*?)rgb\((\d+), (\d+), (\d+)\)/.exec(color);
                var red = parseInt(digits[2]);
                var green = parseInt(digits[3]);
                var blue = parseInt(digits[4]);
                return {
                    r: red,
                    g: green,
                    b: blue
                }
            },
            resetGradientsForColorClass: function(colorClassName) {
                if (typeof itemColor.colorToGradient[colorClassName] !== 'undefined') {
                    for (var iCTG in itemColor.colorToGradient[colorClassName]) {
                        var gradientClass = itemColor.colorToGradient[className][iCTG]['gradientClass'];
                        lengthOfGraduent = itemColor.lineargradients[gradientClass].length;
                        itemColor.setTmpGradient(gradientClass, itemColor.hexToRgb(itemColor.lineargradients[gradientClass][0]['color']),
                            itemColor.hexToRgb(itemColor.lineargradients[gradientClass][lengthOfGraduent - 1]['color']));
                    }
                }
            },
            setGradientsForColorClass: function(colorClassName, colorChange) {
                if (typeof itemColor.colorToGradient[colorClassName] !== 'undefined') {
                    var gradChangeColor = colorChange;
                    for (var iCTG in itemColor.colorToGradient[colorClassName]) {
                        var gradientClass = itemColor.colorToGradient[colorClassName][iCTG]['gradientClass'];
                        lengthOfGraduent = itemColor.lineargradients[gradientClass].length;
                        if (itemColor.colorToGradient[colorClassName][iCTG]['point'] > 0) {
                            itemColor.setGradient(gradientClass, itemColor.hexToRgb(itemColor.lineargradients[gradientClass][0]['color']),
                                itemColor.hexToRgb(gradChangeColor));
                        } else {
                            itemColor.setGradient(gradientClass, itemColor.hexToRgb(gradChangeColor),
                                itemColor.hexToRgb(itemColor.lineargradients[gradientClass][lengthOfGraduent - 1]['color']));
                        }
                    }
                }
            }
        };

        $(document)
            .on('click', 'div.colorChange', function(event) {
                $('.custom-color-picker').css({ 'outline': 'none' });
                $(this).parent().css('outline', 'solid 2px #C43050').css('padding', '1px');
                itemColor.selected = $(this).attr('forClass');
                itemColor.type = $(this).attr('forType');
            })
            .on('mouseenter', 'div.custom-true-color-picker > div', function(event) {
                if (itemColor.selected != '' && itemColor.type != '') {
                    $('[forClass="' + itemColor.selected + '"][forType="' + itemColor.type + '"]')
                        .css('background-color', $(this).css('background-color'));
                    className = itemColor.selected;
                    switch (itemColor.type) {
                        case 'colors':
                        case 'background':
                            $('.' + className).css('fill', $(this).css('background-color'));
                            if (typeof itemColor.colorToGradient[className] !== 'undefined') {
                                var gradChangeColor = itemColor.convertRGB($(this).css('background-color'));
                                gradChangeColor = itemColor.rgbToHex(gradChangeColor.r, gradChangeColor.g, gradChangeColor.b);
                                for (var iCTG in itemColor.colorToGradient[className]) {
                                    var gradientClass = itemColor.colorToGradient[className][iCTG]['gradientClass'];
                                    lengthOfGraduent = itemColor.lineargradients[gradientClass].length;
                                    if (itemColor.colorToGradient[className][iCTG]['point'] > 0) {
                                        itemColor.setTmpGradient(gradientClass, itemColor.hexToRgb(itemColor.lineargradients[gradientClass][0]['color']),
                                            itemColor.hexToRgb(gradChangeColor));
                                    } else {
                                        itemColor.setTmpGradient(gradientClass, itemColor.hexToRgb(gradChangeColor),
                                            itemColor.hexToRgb(itemColor.lineargradients[gradientClass][lengthOfGraduent - 1]['color']));
                                    }
                                }
                            }
                            break;
                    }
                }
            })
            .on('mouseleave', 'div.custom-true-color-picker > div', function(event) {
                if (itemColor.selected != '' && itemColor.type != '') {
                    className = itemColor.selected;
                    switch (itemColor.type) {
                        case 'colors':
                            $('[forClass="' + className + '"][forType="' + itemColor.type + '"]')
                                .css('background-color', itemColor.colors[className]);
                            $('.' + className).css('fill', itemColor.colors[className]);
                            itemColor.resetGradientsForColorClass(className);
                            break;
                        case 'background':
                            $('[forClass="' + className + '"][forType="' + itemColor.type + '"]')
                                .css('background-color', itemColor.background[className]);
                            $('.' + className).css('fill', itemColor.background[className]);
                            itemColor.resetGradientsForColorClass(className);
                            break;
                    }
                }
            })
            .on('click', 'div.custom-true-color-picker > div', function(event) {
                if (itemColor.selected != '' && itemColor.type != '') {
                    className = itemColor.selected;
                    $('[forClass="' + itemColor.selected + '"][forType="' + itemColor.type + '"]')
                        .css('background-color', $(this).css('background-color'));
                    var colorInRgb = itemColor.convertRGB($(this).css('background-color'));
                    var colorInHex = itemColor.rgbToHex(colorInRgb.r, colorInRgb.g, colorInRgb.b);
                    /*Updates ApoloMultimedia */
                    var newColor = $(this).attr('customcolorid');
                    var newTitle = $(this).attr('customColorTitle')
                    $('input[name="customColor[' + className + ']"]').val(newColor);
                    $('input[name="customColorName[' + className + ']"]').val(newTitle + ":" + newColor);
                    /* End Update ApoloMultimedia */
                    switch (itemColor.type) {
                        case 'colors':
                            $('.' + itemColor.selected).css('fill', $(this).css('background-color'));
                            itemColor.colors[className] = colorInHex;
                            itemColor.setGradientsForColorClass(className, colorInHex);
                            break;
                        case 'background':
                            $('.' + itemColor.selected).css('fill', $(this).css('background-color'));
                            itemColor.background[className] = colorInHex;
                            itemColor.setGradientsForColorClass(className, colorInHex);
                            break;
                    }
                    $('input[name="customColor[' + className + ']"]').prev('label').html($(this).attr('customColorTitle'));
                } else {
                    alert('Please select color to change.');
                }
            });
    }

    function hideMyModal(){
        $('#myModal').css({'display':'none'});
    }

    /** DYNAMIC METHODS **/

    function renderDynamicForm(svgData) {
        let qty = 1;
        const html = [];

        html.push('<h5 class="m-0 text-16 letter-spacing-1">To Get A Price Quote:</h5>');
        html.push('<div class="small-text font-italic mb-1">1. Choose Your Garment Type</div>');
        html.push('<div class="small-text font-italic mb-1">2. Choose Colors</div>');
        html.push('<div class="small-text font-italic mb-1">3. Click "Get a Quote"</div>');
        html.push('<br>');
        html.push('<form class="formInfoColors" method="post" action="">');
            html.push('<input type="hidden" name="productId" value="' + productid + '">');
            html.push('<h3 class="mb-5">1. Choose Your Garment Type</h3>');
            html.push('<div class="small-text font-italic mb-1">Search for the garment type you would like, or browse through the below list.</div>');
            html.push('<div class="small-text font-italic mb-1">(Click to select your garment type)</div>');
            html.push('<div class="garments-container">');
                html.push('<div class="searchbox">');
                    html.push('<input type="search" id="garment_search_input" placeholder="Search List of Garment Types">');
                    html.push('<button type="button" id="garment_search_button"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64"><defs><style>.cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px}</style></defs><path class="cls-1" d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"></path></svg></button>');
                html.push('</div>');
                html.push('<div class="garments-scroll-container">');
                    html.push('<div id="garments_list" class="garments-inner"></div>');
                html.push('</div>');
            html.push('</div>');
            //html.push('</div>');

            html.push('<h3 class="mb-5">2. Choose Colors</h3>');
            html.push('<div class="small-text font-italic mb-1">Preview of colors on example garment types</div>');
            html.push('<div class="previewColors">');
                $.each(svgData, function(i, val) {
                    if (val.hide == null) {
                        html.push('<div class="list-colors custom-color-picker-block">');
                        html.push('<span>Color ' + (qty++) + '</span>');
                        html.push('<div class="custom-color-picker">');
                        html.push('<div fortype="' + val.type + '" id="' + val.class + '" class="color colorChange" style="background-color:' + val.colorCode + '" forclass="' + val.class + '">');
                        html.push('<input type="hidden" name="customColorName[' + val.class + ']" value="' + val.colorName + ':' + val.colorCode + '">');
                        html.push('</div>');
                        html.push('</div>');
                        html.push('<label>' + val.colorName + '</label>');
                        html.push('<input type="hidden" name="customColor[' + val.class + ']" id="custom' + val.class +'"  value="' + val.colorCode + '">');
                        html.push('</div>');
                    }
                });
            html.push('</div>');
        html.push('</form>');

        $('#garments').append(html.join(''));
    }

    function loadGarmentsList(){
        const html = [];

        $.ajax({
            url: apiDomain + "api/garments",
            data: {'productid': productid},
            type: 'GET',
            async: false,
            success: function(result) {
                if (result.data.length) {
                    $.each(result.data, function (i, entry) {
                        html.push('<label>');
                            html.push('<input type="checkbox" name="garment_type[]" value="'+entry.id+'" class="js-garment-type"/>');
                            html.push('<figure><img src="'+entry.main_image	+'" alt="'+entry.code+':'+entry.title+'"/></figure>');
                            html.push('<span class="d-block">');
                                html.push('<span class="text-blue font-fold d-block code">'+entry.code+'</span>');
                                html.push('<span class="text-blue font-fold d-block title">'+entry.title+'</span>');
                            html.push('</span>');
                            html.push('<span class="description">'+entry.description+'</span>');
                            if (entry.size_image !== null) {
                                html.push('<a href="#" class="show_garment_size_modal" data-img="' + entry.size_image + '" data-code="' + entry.code + '" data-title="' + entry.title + '">View Size Chart</a>');
                            } else {
                                html.push('<span class="show_garment_size_modal">&nbsp;</span>');
                            }
                        html.push('</label>');
                    });
                }
            }
        });

        $('#garments_list').append(html.join(''));
    }

    function renderDynamicColorsNote() {
        const html = [];

        html.push('<div class="small-text font-italic mb-1">Note: Colors and theme details are approximate.</div>');
        html.push('<div class="small-text font-italic mb-1">Theme elements are not continuous across seam lines</div>');

        $('#colorsNote').append(html.join(''));
    }

    function showGarmentSizeModal(e){
        e.preventDefault();

        const $modal = $('#garmentSizeModal');
        const $btn = $(this);
        const imgSrc = $btn.data('img');
        const code = $btn.data('code');
        const title = $btn.data('title');

        $modal
            .find('.title').text(code + ' - ' + title)
            .end()
            .find('.modal-body').html('<img src="'+imgSrc+'">')
            .end()
            .show();
    }

    function hideGarmentSizeModal(e){
        e.preventDefault();

        const $modal = $('#garmentSizeModal');

        $modal
            .find('.title').empty()
            .end()
            .find('.modal-body').empty()
            .end()
            .hide();
    }

    function garmentSearch(e){
        e.preventDefault();

        const $garmentList = $('#garments_list');
        const filterKeyword = $("#garment_search_input").val()?.toLowerCase();

        $garmentList.find('label').each((i, el) => {
            const $card = $(el);

            // Достаём значения из конкретных полей
            const cardTitle = $card.find(".title").text().toLowerCase();
            const cardCode = $card.find(".code").text().toLowerCase();
            const cardDescription = $card.find(".description").text().toLowerCase();

            // Проверяем совпадения
            const matchTitleKeyword = !filterKeyword || cardTitle.includes(filterKeyword);
            const matchCodeKeyword = !filterKeyword || cardCode.includes(filterKeyword);
            const matchDescriptionKeyword = !filterKeyword || cardDescription.includes(filterKeyword);

            //console.log(matchTitleKeyword, matchCodeKeyword, matchDescriptionKeyword);

            $card.toggle(matchTitleKeyword || matchCodeKeyword || matchDescriptionKeyword);
        });
    }

    function garmentSearchEnter(e){
        if (e.key === 'Enter') {
            e.preventDefault();
            garmentSearch(e);
            return false;
        }
    }

    function garmentSelect() {
        const $parent = $('#garments_list');
        const $checkedInputs = $parent.find('.js-garment-type:checked');

        if ($checkedInputs.length == 4) {
            $parent.find('.js-garment-type:not(:checked)').prop('disabled', true);
        } else {
            $parent.find('[type="checkbox"]').prop('disabled', false);
        }
    }

    /** ARTISAN METHODS **/

    function renderArtisanForm() {
        const html = [];

        html.push('<h5 class="m-0">To Get A Price Quote:</h5>');
        html.push('<div class="small-text mb-1">1. Choose Your Garment Type</div>');
        html.push('<div class="small-text mb-1">2. Enter Your Theme Code</div>');
        html.push('<div class="small-text mb-1">3. Click "Get a Quote"</div>');
        html.push('<br>');
        html.push('<form id="js_form_artisan" method="post" action="">');
            html.push('<input type="hidden" name="productId" value="' + productid + '">');
            html.push('<h3 class="mb-5">1. Choose Your Garment Type</h3>');
            html.push('<div class="small-text font-italic mb-1">Search for the garment type you would like, or browse through the below list.</div>');
            html.push('<div class="small-text font-italic mb-1">(Click to select your garment type)</div>');

            html.push('<div class="garments-container">');
                html.push('<div class="searchbox">');
                    html.push('<input type="search" id="garment_search_input" placeholder="Search List of Garment Types">');
                    html.push('<button type="button" id="garment_search_button"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64"><defs><style>.cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px}</style></defs><path class="cls-1" d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"></path></svg></button>');
                html.push('</div>');
                html.push('<div class="garments-scroll-container">');
                    html.push('<div id="garments_list" class="garments-inner"></div>');
                html.push('</div>');
            html.push('</div>');
            //html.push('</div>');

            html.push('<h3 class="n-0">2. Enter Your Theme Code</h3>');
            html.push('<div class="text-blue mb-1">View our entire library of themes at <a href="https://teamcothemes.com" target="_blank">teamcothemes.com</a></div>');
            html.push('<div class="mb-1"><textarea class="form-control" name="artisan_theme_code" placeholder="Enter Theme Here"></textarea></div>');
            html.push('<button type="button" id="butonSaveArtisan" class="btn btn--full add-to-cart">GET A QUOTE</button>');
        html.push('</form>');

        $('#colorSVG').append(html.join(''));
    }

    function saveArtisanData(){
        let token;
        const $form = $('#js_form_artisan');
        const formData = $form.serializeArray();
        //const artisanThemeContent = $form.find('[name="artisan_theme_code"]').val();
        const productID = $('input[name="productId"]').val();
        const productTitle = $('.product-single__title').html();
        const postData = {"title": productTitle, "color": [], "artisan_theme_code": null, "garment_type": []};

        formData.map((item) => {
            if (item.name === 'garment_type[]') {
                postData['garment_type'].push(item.value);
            } else {
                postData[item.name] = item.value;
            }
        });

        if (document.cookie.indexOf("requestProductToken=") >= 0) {
            token = getCookie("requestProductToken");
        } else {
            token = getToken();
            expiry = new Date();
            expiry.setTime(expiry.getTime() + (100 * 60 * 1000)); // Ten minutes
            document.cookie = "requestProductToken=" + token + "; expires=" + expiry.toGMTString() + ";path=/";
        }
        $('#popup').fadeIn('slow');
        $('.popup-overlay').height($(window).height()).fadeIn('slow');

        const dataRequest = {
            "token": token,
            "product_id": productID,
            "data": postData,
        };

        console.log(dataRequest);

        $.ajax({
            url: apiDomain + "api/storeProduct",
            type: 'POST',
            data: dataRequest,
            dataType: 'json',
            async: false
        });

        $('#my-quote-icon').removeClass('hide');

        $('#myModal').css({'display':'block'});
    }

    /** GLOBAL EVENTS **/

    $(document)
        .on('change', '.js-garment-type', garmentSelect)
        .on('keydown', '#garment_search_input', garmentSearchEnter)
        .on('click', '#garment_search_button', garmentSearch)
        .on('click', '#myModal .close', hideMyModal)
        .on('click', '#garmentSizeModal .close', hideGarmentSizeModal)
        .on('click', '.show_garment_size_modal', showGarmentSizeModal)
        .on('click', '#butonSaveArtisan', saveArtisanData)
        .on('click', '#butonSaveLocal', saveClassicData)
        .on('click', '#saveSVG', saveSVG);
});
